import { useEffect } from 'react'
import Router from './Router'
import Cookies from 'js-cookie'
import { useLocation, useNavigate } from 'react-router-dom'
import GlobalStyles from './styles/GlobalStyles'
import { useAuthCheck, useAxios } from './hook'

function App() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { checkAuth } = useAuthCheck()
  useAxios()
  const RT = Cookies.get('RT')

  useEffect(() => {
    // 이상한 url 갈때ㅑ컨트롤
    if (pathname.startsWith("/docs")) return
    if (!RT && !pathname.startsWith('/unauth')) return window.location.replace('/unauth/signin')
    if (RT && checkAuth('10000') && pathname.startsWith('/unauth')) return navigate('/upload')
    if (RT && pathname.startsWith('/unauth')) return navigate('/history')
    if (checkAuth('10000') && !pathname.startsWith('/upload')) return navigate('/upload')
    if(!checkAuth('1110') && pathname.startsWith('/user')) return navigate('/history')
    if(!checkAuth('1100') && pathname.startsWith('/part')) return navigate('/history')
    if(!checkAuth('1110') && pathname.startsWith('/group')) return navigate('/history')
    if(!checkAuth('1110') && pathname.startsWith('/activity')) return navigate('/history')
    if(!checkAuth('1000') && pathname.startsWith('/calc')) return navigate('/history')

  }, [pathname])

  return (
    <>
      <GlobalStyles />
      <Router user={{ RT }} />
    </>
  )
}

export default App
